import { createSlice } from '@reduxjs/toolkit'
import { createAxiosThunk } from 'utils/reduxUtil'
import api from 'api/axios/foka'
import Limitations from 'features/Limitations'

const { BIZ_CHANNEL_MAX_CREATIVES } = Limitations

const initialState = {
  bizChannelId: null,
  channel: null,
  creatives: [],
  apiError: null,
  creativeLinks: [],
  isChannelLoading: false,
  isCreativeLoading: false,
}

export const fetchCreatives = createAxiosThunk(
  'groupCreative/fetchCreatives',
  channelId =>
    api.creative.getCreatives({
      bizChannelIds: [channelId],
      creativeStatus: ['ON'],
      page: 0,
      size: BIZ_CHANNEL_MAX_CREATIVES,
      sort: 'createdDate desc',
    })
)

export const fetchBizChannel = createAxiosThunk(
  'groupCreative/fetchBizChannel',
  channelId => api.ad.getBizChannel(channelId)
)

export const fetchCreativeLinks = createAxiosThunk(
  'groupCreative/fetchCreativeLinks',
  groupId => api.ad.getCreativeLinksByAdGroup(groupId)
)

const groupCreativeSlice = createSlice({
  name: 'groupCreative',
  initialState,

  reducers: {
    reset: () => initialState,
  },

  extraReducers: builder => {
    builder.addCase(fetchCreatives.pending, state => {
      state.isCreativeLoading = true
    })

    builder.addCase(fetchCreatives.fulfilled, (state, { payload }) => {
      state.creatives = payload.creatives.content
      state.isCreativeLoading = false
    })

    builder.addCase(fetchCreatives.rejected, (state, { error }) => {
      state.apiError = error || true
      state.isCreativeLoading = false
    })

    builder.addCase(fetchBizChannel.pending, state => {
      state.isChannelLoading = true
    })

    builder.addCase(fetchBizChannel.fulfilled, (state, { payload }) => {
      state.channel = payload
      state.isChannelLoading = false
    })

    builder.addCase(fetchBizChannel.rejected, (state, { error }) => {
      state.isChannelLoading = false
      state.apiError = error || true
    })

    builder.addCase(fetchCreativeLinks.fulfilled, (state, { payload }) => {
      state.creativeLinks = payload.creativeLinkDtos.map(dto => dto.creativeId)
    })
  },
})

export const { reset } = groupCreativeSlice.actions

export default groupCreativeSlice.reducer
